import React, { useState } from 'react';
import classNames from 'classnames';
import axios from 'axios';

import css from './CtaForm.module.scss';

const CtaForm = ({ customClass }) => {
	const [{ email, emailValid }, setEmail] = useState({});
	const [{ phone, phoneValid }, setPhone] = useState({});
	const [{ ctaButtonText, ctaButtonDisabled }, setCtaButton] = useState({
		ctaButtonText: 'Get Info',
		ctaButtonDisabled: false,
	});
	const [apiError, setApiError] = useState(false);
	const [submittedOnce, setSubmittedOnce] = useState(false);

	const isEmailValid = e => {
		setApiError(false);
		const enteredEmail = e.target.value;

		// Regex source: https://emailregex.com/
		if (
			/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
				enteredEmail
			)
		) {
			setEmail({ email: enteredEmail, emailValid: true });
			return true;
		}
		setEmail({ email: undefined, emailValid: false });
		return false;
	};

	const isPhoneValid = e => {
		setApiError(false);
		const enteredPhone = e.target.value;

		if (/^[6-9]\d{9}$/.test(enteredPhone)) {
			setPhone({ phone: enteredPhone, phoneValid: true });

			return true;
		}
		setPhone({ phone: undefined, phoneValid: false });
		return false;
	};

	const handleSubmit = e => {
		setSubmittedOnce(true);
		e.preventDefault();

		// Both Email and phone are valid
		if (email && phone) {
			setCtaButton({ ctaButtonText: 'Submitting...', ctaButtonDisabled: true });
			axios
				.post('https://moneyfront-email.herokuapp.com/', {
					// TODO: change this
					email,
					phone,
					pageUrl: window.location.href,
				})
				.then(res => {
					window.location = '/thank-you';
				})
				.catch(err => {
					setCtaButton({
						ctaButtonText: 'Get Info',
						ctaButtonDisabled: false,
					});
					setApiError(true);
				});

			// Do something here
			// return true;
		}

		// // Only email is valid
		// if (email) {
		// 	return true;
		// }

		// // Only phone is valid
		// if (phone) {
		// 	return true;
		// }

		// // Both Email and phone are invalid
		// return true;
	};

	return (
		<>
			<form
				onSubmit={e => handleSubmit(e)}
				method="post"
				className={css.ctaForm}
			>
				<div className={css.formItem}>
					<label htmlFor="email">Email</label>
					<input
						type="text"
						id="email"
						name="email"
						onChange={e => isEmailValid(e)}
						placeholder="Enter your Email ID"
						required
					/>
				</div>
				<div className={css.formItem}>
					<label htmlFor="phone">Phone</label>
					<input
						type="text"
						id="phone"
						name="phone"
						onChange={e => isPhoneValid(e)}
						placeholder="Enter your phone number"
						required
					/>
				</div>
				<button className={css.formItem} disabled={ctaButtonDisabled}>
					{ctaButtonText}
				</button>
			</form>

			<div className={classNames(css.apiError, apiError && css.show)}>
				Something went wrong! Please try again later.
			</div>

			<div className={classNames(css.validationErrors, css[customClass])}>
				<span
					className={classNames(
						css.error,
						submittedOnce && emailValid === false && css.errorEmail
					)}
				>
					Please enter a valid email address
				</span>
				<span
					className={classNames(
						css.error,
						submittedOnce && phoneValid === false && css.errorPhone
					)}
				>
					Please enter a valid phone number
				</span>
			</div>
		</>
	);
};

export default CtaForm;
